import { render } from "./ImportWorkout.vue?vue&type=template&id=ce587ed8"
import script from "./ImportWorkout.vue?vue&type=script&lang=js"
export * from "./ImportWorkout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__